import { DeviceType } from '../device-type.model';

export class CommCardDetailed
{
    constructor(json: any)
    {
        Object.assign(this, json);

        if (json.WhenCreated) this.WhenCreated = new Date(json.WhenCreated);
        if (json.WhenLastUpdated) this.WhenLastUpdated = new Date(json.WhenLastUpdated);
    }

    public BootVersion: number;
    public Device: any;                     // TODO: MW - Define
    public DeviceId: number;
    public DeviceType: DeviceType;
    public DeviceTypeId: number;
    public FirmwareDescription: string;
    public FirmwareVersion: number;
    public HardwareVersion: number;
    public Id: number;
    public UId: string;
    public WhenCreated: Date;
    public WhenLastUpdated: Date;

}
